import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, Progressivi } from '../../models/-index';

@Injectable()
export class ProgressiviService extends CrudGenericsService<Progressivi, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Progressivi`);
    this.base = `${env.apiUrl}/api/Progressivi/`;
  }

  // rigenera tutti i codici!
  RigeneraTuttiCodici(item: Progressivi) {
    const u = `${this.base}RigeneraTuttiCodici`;
    return this.http.post(u, item);
  }
}
